module.exports = __webpack_public_path__ + "static/media/curriculumKit__software--cad.1cdd457d.jpg";